// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  -webkit-backdrop-filter: blur(1px);
          backdrop-filter: blur(1px);
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
}

#lottie-loader {
  width: 250px;
  height: 250px;
  background: transparent;
}

.loading-message {
  position: absolute;
  top: 60%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 18px;
  color: #fff;
  z-index: 9999;
}`, "",{"version":3,"sources":["webpack://./src/app/components/lottie-loader/lottie-loader.component.scss"],"names":[],"mappings":"AA+BA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,oCAAA;EACA,kCAAA;UAAA,0BAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA9BF;;AAkCA;EACE,YAAA;EACA,aAAA;EACA,uBAAA;AA/BF;;AAmCA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;AAhCF","sourcesContent":["// .loader-overlay {\r\n//   position: fixed;\r\n//   top: 0;\r\n//   left: 0;\r\n//   width: 100%;\r\n//   height: 100%;\r\n//   background-color: rgba(0, 0, 0, 0.6);\r\n//   backdrop-filter: blur(2px);\r\n//   z-index: 9999;\r\n//   display: flex;\r\n//   align-items: center;\r\n//   justify-content: center;\r\n// }\r\n\r\n// #lottie-loader {\r\n//   width: 250px;\r\n//   height: 250px;\r\n//    background: transparent;\r\n// }\r\n\r\n// .loading-message {\r\n//   position: absolute;\r\n//   top: 60%;\r\n//   left: 50%;\r\n//   transform: translate(-50%, -50%);\r\n//   font-size: 18px;\r\n//   color: #fff;\r\n//   z-index: 9999;\r\n// }\r\n\r\n\r\n.loader-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100vw;\r\n  height: 100vh;\r\n  background-color: rgba(0, 0, 0, 0.6);\r\n  backdrop-filter: blur(1px);\r\n  z-index: 99999;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n \r\n}\r\n\r\n#lottie-loader {\r\n  width: 250px;\r\n  height: 250px;\r\n  background: transparent;\r\n    // border: 5px solid red;\r\n}\r\n\r\n.loading-message {\r\n  position: absolute;\r\n  top: 60%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  font-size: 18px;\r\n  color: #fff;\r\n  z-index: 9999;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
